import React, { memo } from 'react';
import { useWindowSize } from '@surveycake/rhooks';
import { addOptionPrefix } from 'app/modules/subject';
import {
  Grid,
  MultiOption,
  ElseTextField
} from 'app/pages/Survey/Subject/elements';
import { useChoiceMultiAnswer } from './hooks';

function Answer() {
  const {
    columnDesktop,
    columnMobile,
    options,
    optionStates,
    onElseChange,
    value: valuesFromAnswer,
    elseValue,
    onChange
  } = useChoiceMultiAnswer();
  const { width } = useWindowSize();
  const isWide = width >= 720;
  const currentColumn = isWide ? columnDesktop : columnMobile;

  if (!options || !optionStates) {
    return null;
  }

  return (
    <Grid column={currentColumn} gutter={10}>
      {options.map(({ ID, text, imgs, youtubeid, elses }) => {
        const value = addOptionPrefix(ID);
        const checked = valuesFromAnswer.includes(value);
        const { excluded, visible, enable } = optionStates[ID];
        const disabled = !enable;
        const imageLink = imgs ? imgs : '';
        const youtubeID = youtubeid ? youtubeid : '';

        if (!visible) {
          return null;
        }

        return (
          <MultiOption
            key={value}
            Id={ID}
            value={value}
            label={text}
            checked={checked}
            excluded={excluded}
            disabled={disabled}
            imageLink={imageLink}
            youtubeID={youtubeID}
            onChange={onChange}
          >
            {elses === 1 && checked && (
              <ElseTextField initialValue={elseValue} onChange={onElseChange} />
            )}
          </MultiOption>
        );
      })}
    </Grid>
  );
}

export default memo(Answer);
